import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { useVisualBlocksContext } from '../VisualBlocksContext'
import SplitListItem from './SplitListItem'

const useStyles = makeStyles(() => ({
  listItemList: {
    '& > *:not(:last-child)': {
      borderBottom: '1px solid #E0E0E0'
    }
  }
}))

function SplitSubList ({ item, depth, maxListDepth }) {
  const classes = useStyles()
  const { classNames, styles } = useVisualBlocksContext()

  return (
    <div
      className={clsx('flex flex-1 flex-col gap-1', classNames.listItemContainer)} style={{
        minWidth: '500px',
        ...styles?.listItemContainer
      }}
    >
      <p
        className='font-size-sm'
        style={{ marginLeft: depth * 10, textTransform: 'uppercase' }}
      >
        {item.label}
      </p>
      {!item.details?.length && depth >= maxListDepth ? (
        <>
          {item.details.map((subItem) => (
            <SplitSubList
              key={subItem.id}
              item={subItem}
              depth={depth + 1}
              maxListDepth={maxListDepth}
            />
          ))}
        </>
      ) : (
        <div
          className={clsx(
            classes.listItemList,
            'flex flex-col',
            classNames?.listItemList ?? ''
          )}
        >
          {item.details.map((subItem) => (
            <SplitListItem key={subItem.id} item={subItem} depth={depth} />
          ))}
        </div>
      )}
    </div>
  )
}

SplitSubList.propTypes = {
  item: PropTypes.object.isRequired,
  depth: PropTypes.number.isRequired,
  maxListDepth: PropTypes.number.isRequired
}

export default SplitSubList
